import axiosClient from "./axiosClient";

export async function adminAuth(email: string, pass: string) {
  const bodyReq = {
    email: email,
    password: pass,
  };
  try {
    const response = await axiosClient.post("/auth/admin/login", bodyReq);

    if (response.status !== 200) {
      console.warn(`Admin auth response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export async function adminBookingLogin(bookingNumber: string) {
  const bodyReq = {
    bookingNumber: bookingNumber,
  };
  try {
    const response = await axiosClient.post("/auth/admin/booking-login", bodyReq);

    if (response.status !== 200) {
      console.warn(`Admin booking login response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export async function adminAutocomplete(query: string) {
  try {
    const response = await axiosClient.get(`/auth/admin/autocomplete?query=${query}`);

    if (response.status !== 200) {
      console.warn(`Admin autocomplete response is not 200 ok!`);
      return [];
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return [];
  }
}
